module.exports = __webpack_public_path__ + "static/media/sleepnix-3.4882878a.jpg";